import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { GatsbyImage } from 'gatsby-plugin-image'


const ModalVideo = ({ id, title, youtubeID, caption, videoImageThumbnail }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const safeCaption = caption || "";
  
    return (
      <div>
        <div class="video-modal" onClick={handleShow}>
          <GatsbyImage alt="Play Video" image={videoImageThumbnail.gatsbyImageData} style={{ maxWidth: '100%' }} />
        </div>
  
        <Modal 
            key={id}
            size="lg" 
            show={show} 
            onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="aspect-ratio-16-9">
              <iframe 
                  src={`https://www.youtube.com/embed/${youtubeID}`}
                  title="YouTube video player" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  allowFullScreen
              ></iframe>
            </div>
            {renderRichText(safeCaption)}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
}

export default ModalVideo;



